import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { geozoneApi } from '../../api';
import { IGeozoneStore } from './store.types';

export const useGeozoneStore = create<IGeozoneStore>()(immer((set) => ({
  list: [],
  async fetchGeozones(customerId) {
    const result = await geozoneApi.getGeozones({ customerId });

    set({ list: result.items });

    return result.items;
  },
  async addGeozone(customerId, payload) {
    const result = await geozoneApi.createGeozone({ customerId, createGeozone: payload });

    set(state => {
      state.list.push(result);
    });

    return result;
  },
  async deleteGeozone(customerId, geozoneId) {
    await geozoneApi.deleteGeozone({ customerId, geozoneId });

    set(state => {
      state.list = state.list.filter(el => el.id !== geozoneId);
    })
  }
})));
